import produce from 'immer';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import * as Scopes from 'automation-ui-canvas/constants/Scopes';
import LockedNotificationsToggle from 'automation-ui-canvas/components/settings/v2/LockedNotificationsToggle';
import UIBox from 'UIComponents/layout/UIBox';
import ManualEnrollmentConfig from 'automation-ui-canvas/components/settings/v2/ManualEnrollmentConfig';
import { useEffect, useState } from 'react';
import UIToggle from 'UIComponents/input/UIToggle';
import { useHasScope } from 'automation-ui-core/hooks/authHooks';
import { AIBadge } from 'ai-components-ui-library/components/informative/AIBadge';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EnrollmentNotificationSettingsForm = ({
  aiBasedEnrollmentConfig,
  manualEnrollmentConfig,
  readOnly,
  handleManualEnrollmentConfigChange,
  handleAIBasedEnrollmentConfigChange
}) => {
  const hasAnomalyNotificationsScope = useHasScope(Scopes.WORKFLOWS_ANOMALY_NOTIFICATIONS);
  const [parentToggleIsOn, setParentToggleIsOn] = useState((aiBasedEnrollmentConfig === null || aiBasedEnrollmentConfig === void 0 ? void 0 : aiBasedEnrollmentConfig.isEnabled) || (manualEnrollmentConfig === null || manualEnrollmentConfig === void 0 ? void 0 : manualEnrollmentConfig.isEnabled));
  const showExpandedNotificationSection = (aiBasedEnrollmentConfig === null || aiBasedEnrollmentConfig === void 0 ? void 0 : aiBasedEnrollmentConfig.isEnabled) || (manualEnrollmentConfig === null || manualEnrollmentConfig === void 0 ? void 0 : manualEnrollmentConfig.isEnabled) || parentToggleIsOn;
  useEffect(() => {
    if (aiBasedEnrollmentConfig !== null && aiBasedEnrollmentConfig !== void 0 && aiBasedEnrollmentConfig.isEnabled || manualEnrollmentConfig !== null && manualEnrollmentConfig !== void 0 && manualEnrollmentConfig.isEnabled) {
      setParentToggleIsOn(true);
    }
  }, [aiBasedEnrollmentConfig, manualEnrollmentConfig]);
  const parentEnrollmentNotificationToggle = /*#__PURE__*/_jsx(LockedNotificationsToggle, {
    scope: Scopes.WORKFLOWS_ANOMALY_NOTIFICATIONS,
    checked: parentToggleIsOn,
    onChange: ({
      target: {
        checked
      }
    }) => {
      if (!hasAnomalyNotificationsScope) {
        setParentToggleIsOn(false);
      } else {
        const updatedAIEnrollmentNotificationConfig = produce(aiBasedEnrollmentConfig, draftNotificationConfig => {
          draftNotificationConfig.isEnabled = checked;
        });
        handleAIBasedEnrollmentConfigChange(updatedAIEnrollmentNotificationConfig);
        if (!checked) {
          const updatedEnrollmentNotificationConfig = produce(manualEnrollmentConfig, draftNotificationConfig => {
            draftNotificationConfig.isEnabled = checked;
          });
          handleManualEnrollmentConfigChange(updatedEnrollmentNotificationConfig);
        }
        setParentToggleIsOn(checked);
      }
    },
    readOnly: readOnly
  });
  const manualEnrollmentToggleElement = /*#__PURE__*/_jsx(UIToggle, {
    checked: manualEnrollmentConfig === null || manualEnrollmentConfig === void 0 ? void 0 : manualEnrollmentConfig.isEnabled,
    onChange: ({
      target: {
        checked
      }
    }) => {
      const updatedNotificationConfig = produce(manualEnrollmentConfig, draftNotificationConfig => {
        draftNotificationConfig.isEnabled = checked;
      });
      handleManualEnrollmentConfigChange(updatedNotificationConfig);
    },
    readOnly: readOnly
  });
  const aiToggleElement = /*#__PURE__*/_jsx(UIToggle, {
    checked: aiBasedEnrollmentConfig === null || aiBasedEnrollmentConfig === void 0 ? void 0 : aiBasedEnrollmentConfig.isEnabled,
    onChange: ({
      target: {
        checked
      }
    }) => {
      const updatedNotificationConfig = produce(aiBasedEnrollmentConfig, draftNotificationConfig => {
        draftNotificationConfig.isEnabled = checked;
      });
      handleAIBasedEnrollmentConfigChange(updatedNotificationConfig);
    },
    readOnly: readOnly
  });
  const {
    notificationCadence
  } = manualEnrollmentConfig.rule;
  return /*#__PURE__*/_jsxs("div", {
    className: "m-top-2",
    children: [/*#__PURE__*/_jsx(UIFlex, {
      justify: "between",
      align: "center",
      children: /*#__PURE__*/_jsx(UIBox, {
        children: parentEnrollmentNotificationToggle
      })
    }), showExpandedNotificationSection && /*#__PURE__*/_jsxs(UIFlex, {
      justify: "between",
      className: "m-y-4",
      children: [/*#__PURE__*/_jsxs(UIFlex, {
        gap: 8,
        align: "center",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "settingsV2.enrollmentNotificationSetting.v2.useAI"
        }), /*#__PURE__*/_jsx(AIBadge, {})]
      }), /*#__PURE__*/_jsx(UIBox, {
        children: aiToggleElement
      })]
    }), showExpandedNotificationSection && /*#__PURE__*/_jsxs(UIFlex, {
      justify: "between",
      className: "m-y-4",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "settingsV2.enrollmentNotificationSetting.v2.useManualRange"
      }), /*#__PURE__*/_jsx(UIBox, {
        children: manualEnrollmentToggleElement
      })]
    }), showExpandedNotificationSection && (manualEnrollmentConfig === null || manualEnrollmentConfig === void 0 ? void 0 : manualEnrollmentConfig.isEnabled) && /*#__PURE__*/_jsx(ManualEnrollmentConfig, {
      readOnly: readOnly,
      notificationCadence: notificationCadence,
      manualEnrollmentConfig: manualEnrollmentConfig,
      handleManualEnrollmentConfigChange: handleManualEnrollmentConfigChange
    })]
  });
};
export default EnrollmentNotificationSettingsForm;